export default __webpack_public_path__ + "static/media/paymentTutorial_pc_bottom_En.5f4774b9.webp";